export const version = "wallet/5.1.0";
//# sourceMappingURL=_version.js.map